import { genericCRUDService, search } from '../../helpers/api';

export const SERVICE_URI = '/tvm';
export const BASE_URI = '/api/v1/alerts';
export const { findAll } = genericCRUDService(SERVICE_URI, BASE_URI);

export const getAlertList = async (data) =>
  search(`${SERVICE_URI}${BASE_URI}`, data);
